function megamenu() {
  const menu = document.querySelector("#desktopHeaderAB");
  const firstLevelItems = menu?.querySelectorAll(".navlink--toplevel");
  const secondLevelDrawers = menu?.querySelectorAll(".menu__item--drawer");
  const overlays = menu?.querySelectorAll(".overlay");
  if (menu === null) return;

  firstLevelItems.forEach((firstLevelItem) => {
    let closeTimeout;
    const noMenu = firstLevelItem.matches('a.navlink--toplevel');

    firstLevelItem.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
      firstLevelItems.forEach((item) => {
        item.closest(".menu__item")?.setAttribute("aria-expanded", "false");
        menu
          ?.querySelectorAll('.menu__item[aria-expanded="true"]')
          .forEach((subitem) => {
            subitem.setAttribute("aria-expanded", "false");
          });
      });

      firstLevelItem.closest(".menu__item")?.setAttribute("aria-expanded", "true");
      // console.log(firstLevelItem);
      if (noMenu == false) {
        // document.body.classList.add("no-scroll");
        document.body.classList.remove("no-scroll"); // temp removal of all no-scroll to allow scrolling with megamenu open
      }
    });

    if (noMenu) {
      firstLevelItem.addEventListener("mouseleave", () => {
        closeTimeout = setTimeout(() => {
          firstLevelItem.closest(".menu__item")?.setAttribute("aria-expanded", "false");
          document.body.classList.remove("no-scroll");
        }, 200);
      });
    }
  });

  overlays.forEach((overlay) => {
    overlay.addEventListener("click", () => {
      overlay.closest(".menu__item").setAttribute("aria-expanded", "false");
      document.body.classList.remove("no-scroll");
    });
  });

  secondLevelDrawers.forEach((drawer) => {
    const closeIcon = drawer.querySelector(".menu__item--drawer-close");
    const secondLevelItems = drawer.querySelectorAll('.navlink--secondlevel:not(.title-second-drawer)');
    const thirdLevelDrawers = drawer.querySelectorAll(
      ".menu__item--second-drawer"
    );

    closeIcon.addEventListener("click", () => {
      drawer.closest(".menu__item").setAttribute("aria-expanded", "false");
      document.body.classList.remove("no-scroll");
    });

    secondLevelItems.forEach((secondLevelItem) => {
      secondLevelItem
        .closest(".menu__item")?.addEventListener("mouseover", () => {
          const menuItem = secondLevelItem.closest(".menu__item");
          const isExpanded = menuItem.getAttribute("aria-expanded") === "true";
          menuItem.setAttribute("aria-expanded", !isExpanded);

          if (!isExpanded) {
            secondLevelItems.forEach((item) => {
              const itemMenu = item.closest(".menu__item");
              if (itemMenu !== menuItem) {
                itemMenu?.setAttribute("aria-expanded", "false");
              }
            });

            closeIcon.classList.add("hidden");
          }
        });

      secondLevelItem
        .closest(".menu__item")?.addEventListener("mouseout", () => {
          const menuItem = secondLevelItem.closest(".menu__item");
          const isExpanded = menuItem?.getAttribute("aria-expanded") === "true";
          menuItem.setAttribute("aria-expanded", !isExpanded);

          closeIcon.classList.remove("hidden");
        });
    });

    thirdLevelDrawers.forEach((thirdLevelDrawer) => {
      const secondCloseIcon = thirdLevelDrawer.querySelector(
        ".menu__item--drawer-close"
      );

      secondCloseIcon.addEventListener("click", () => {
        thirdLevelDrawer
          .closest(".menu__item")?.setAttribute("aria-expanded", "false");
        drawer.closest(".menu__item")?.setAttribute("aria-expanded", "false");
        closeIcon.classList.remove("hidden");
        document.body.classList.remove("no-scroll");
      });
    });
  });
}

function mobileMegamenu() {
  const hamburguerButton = document.querySelector(
    ".header__ab___mobile__hamburger"
  );
  const menu = document.querySelector("#mobileHeaderAB");
  const drawer = menu?.querySelector(".menu__item--drawer-mobile");
  const closeButtons = drawer.querySelectorAll(".menu__item--drawer-close");
  const backButtons = drawer.querySelectorAll(".menu__item--drawer-back");
  const menuItems = drawer.querySelectorAll(".navlink--secondlevel");
  const secondDrawers = drawer.querySelectorAll(".menu__item--second-drawer");

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      drawer.classList.remove("show");
      document.body.classList.remove("no-scroll");

      menuItems.forEach((menuItem) => {
        menuItem.closest(".menu__item")?.setAttribute("aria-expanded", "false");
      });
    });
  });

  hamburguerButton.addEventListener("click", () => {
    drawer.classList.toggle("show");
    document.body.classList.toggle("no-scroll");
  });

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("click", () => {
      // console.log(menuItem);

      menuItems.forEach((menuItem) => {
        menuItem.closest(".menu__item")?.setAttribute("aria-expanded", "false");
      });

      menuItem.closest(".menu__item")?.setAttribute("aria-expanded", "true");
    });

    const imageElement = menuItem
      .closest(".menu__item")
      ?.querySelector(".menu__item--collection-image");
    if (imageElement != null) {
      imageElement.addEventListener("click", () => {
        menuItems.forEach((menuItem) => {
          menuItem
            .closest(".menu__item")
            .setAttribute("aria-expanded", "false");
        });

        menuItem.closest(".menu__item")?.setAttribute("aria-expanded", "true");
      });
    }
  });

  backButtons.forEach((backButton) => {
    backButton.addEventListener("click", () => {
      menuItems.forEach((menuItem) => {
        // console.log(menuItem);
        menuItem.closest(".menu__item")?.setAttribute("aria-expanded", "false");
      });
    });
  });

  secondDrawers.forEach((secondDrawer) => {
    const secondLevelItems = secondDrawer.querySelectorAll(
      ".navlink--thirdlevel"
    );
    const backButtons = secondDrawer.querySelectorAll(
      ".menu__item--drawer-back--last"
    );

    backButtons.forEach((backButton) => {
      backButton.addEventListener("click", () => {
        secondLevelItems.forEach((secondLevelItem) => {
          secondLevelItem
            .closest(".menu__item")
            ?.setAttribute("aria-expanded", "false");
        });
      });
    });

    secondLevelItems.forEach((secondLevelItem) => {
      secondLevelItem.addEventListener("click", () => {
        secondLevelItems.forEach((secondLevelItem) => {
          secondLevelItem
            .closest(".menu__item")
            ?.setAttribute("aria-expanded", "false");
        });

        secondLevelItem
          .closest(".menu__item")
          ?.setAttribute("aria-expanded", "true");
      });
    });
  });
}

megamenu();
mobileMegamenu();
